<template>
  <div class="content">
    <slot class="title" name="title" />
    <slot class="description" name="description" />
    <user-flow-step :steps="steps"></user-flow-step>
    <slot class="note" name="note" />
    <brand-button class="statusButton" @click="onClick">
      <slot class="buttonLabel" name="buttonLabel" />
    </brand-button>
  </div>
</template>

<script>
import UserFlowStep from '@/components/UserFlowStep';

export default {
  name: 'status',
  props: {
    stepStatuses: {
      type: Array,
      required: true,
    },
  },
  components: {
    UserFlowStep,
  },
  data() {
    return {
      stepsTemplate: [
        {
          iconName: 'Icons_Communication_Desktop',
          title: this.$t('status.steps.apply.title'),
          subtitle: this.$t('status.steps.apply.subtitle'),
        },
        {
          iconName: 'Icons_Business_Tailored',
          title: this.$t('status.steps.customize.title'),
          subtitle: this.$t('status.steps.customize.subtitle'),
        },
        {
          iconName: 'Icons_Actions_Thumbs Up',
          title: this.$t('status.steps.finalize.title'),
          subtitle: this.$t('status.steps.finalize.subtitle'),
        },
      ],
    };
  },
  computed: {
    steps() {
      return this.stepsTemplate.map((step, index) => {
        return {
          ...step,
          status: this.stepStatuses[index],
        };
      });
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>
<style lang="sass" scoped>
.content
  display: flex
  flex-direction: column
  align-items: center

.title
  +mq($stego)
    margin-top: baseunit(6.8)

.description
  margin-top: $glass-spacing-3
  margin-bottom: $glass-spacing-4
  +font-size(13.33)
  width: 100%
  color: $color-system-neutral-gray-5
  +mq($stego)
    width: baseunit(87)

.note
  margin-top: $glass-spacing-4
  margin-bottom: $glass-spacing-2
  +font-size(13.33)
  width: 100%
  +mq($stego)
    width: baseunit(80)

.statusButton
  margin-top: $glass-spacing-2
  margin-bottom: $glass-spacing-5

::v-deep
  .step
    .title
      font-weight: bold

    &.pending
      .image .icon
        color: $color-primary-brand-light

      .line
        background-color: $color-primary-brand-light

      .progress
        .circle
          display: none
</style>
